import React from 'react';
import { ArrowLeft, Plus } from 'phosphor-react';

interface SkinProgressHeaderProps {
  logCount: number;
  onBack: () => void;
  onAdd: () => void;
}

export default function SkinProgressHeader({ logCount, onBack, onAdd }: SkinProgressHeaderProps) {
  return (
    <header className="bg-white dark:bg-gray-900 shadow-soft dark:border-b dark:border-gray-700 px-5 pt-12 pb-5">
      <div className="max-w-lg mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            className="p-2 -ml-2 text-nude-400 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 rounded-xl transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">Registro de Pele</h1>
            <p className="text-sm text-nude-500 dark:text-gray-400 mt-0.5">
              {logCount > 0 ? `${logCount} registro${logCount > 1 ? 's' : ''}` : 'Nenhum registro ainda'}
            </p>
          </div>
        </div>
        <button
          onClick={onAdd}
          className="flex items-center gap-1.5 px-3 py-2 bg-blush-400 hover:bg-blush-500 text-white text-xs font-semibold rounded-xl transition-colors shadow-sm"
        >
          <Plus className="w-3.5 h-3.5" />
          Adicionar
        </button>
      </div>
    </header>
  );
}
